const emojiRe =
    /(?:\p{Extended_Pictographic}|\p{Emoji_Presentation}|\p{Emoji}\uFE0F|[#*0-9]\uFE0F?\u20E3)/u;

export const hasEmoji = (s: unknown): boolean =>
    typeof s === 'string' && emojiRe.test(s);
